var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"reference":_vm.reference,"reference-event-log":_vm.referenceEventLog,"current-researcher":_vm.currentResearcher,"bottom-node":_vm.bottomNode}})}
var staticRenderFns = []

export { render, staticRenderFns }